(fn => (document.readyState !== 'loading') ? fn() : document.addEventListener('DOMContentLoaded', fn))(async ()=>{
  //countdown with HHMMSS
  const element = document.getElementById('countdown');
  if(!element) return;
  const targetTime = new Date(element.getAttribute('data-target')).getTime();

  countdown(targetTime, element);
  setInterval(()=>{
    countdown(targetTime, element);
  }, 1000);
})

function countdown(targetTime, element){
  let left = Math.ceil((targetTime - Date.now()) / 1000);
  if(left < 0){
    left = 0;
    element.classList.add('reached');
  }

  let hour = format(Math.floor(left /3600 ));
  let minutes = format(Math.floor((left % 3600) / 60));
  let seconds = format(left % 60);

  element.querySelector('.hour').innerHTML = hour;
  element.querySelector('.minutes').innerHTML = minutes;
  element.querySelector('.seconds').innerHTML = seconds;
}

function format(n){
  if(n === 0) return "00";
  if(n < 10) return "0" + n;
  return n;
}